import { Form } from 'antd';
import View from '../View';
import styled from 'styled-components';

const FormProvider = Form.Provider;

const FormItem = styled(Form.Item)`
  .ant-form-item-control-input-content {
    max-width: 100%;
  }
  .ant-form-item-label {
    text-align: left;
  }
  .ant-form-item-label > label::after {
    content: '';
  }
  .ant-input-number {
    width: 100%;
  }
`;

const Field = styled(FormItem)`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  margin-right: 15px;
  flex: 1;
`;

const GroupField = styled(View)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  div:first-child {
    margin-left: 0px;
  }
`;

Form.Item = FormItem;
Form.Provider = FormProvider;

const FormCadastro = styled(Form)`
  background-color: #fff;
  padding: 15px;
  padding-right: 0;
  border-radius: 5px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  width: 80%;
`;

export { Form, FormCadastro, Field, GroupField };
